module.exports = __webpack_public_path__ + "img/email.2a4c8733.svg";